import { OrganizationsResponse, TeamModel } from 'types';

import { normalizePaidAccount } from './account';
import genericNormalizer from './generic';
import { membershipsFromResponse } from './memberships';

export const normalizeTeam = genericNormalizer<
  OrganizationsResponse,
  TeamModel
>(({ from, has }) => ({
  desc: from('desc'),
  descData: from('descData'),
  displayName: from('displayName'),
  id: from('id'),
  idEnterprise: from('idEnterprise'),
  limits: from('limits'),
  logos: has('logoHash', (logoHash) => {
    return logoHash
      ? ['30', '50', '170'].reduce((logos: { [key: string]: string }, size) => {
          logos[size] = `${__TEAM_LOGOS_ROOT__}/${logoHash}/${size}.png`;

          return logos;
        }, {})
      : null;
  }),
  memberships: membershipsFromResponse,
  name: from('name'),
  paidAccount: has('paidAccount', normalizePaidAccount),
  prefs: from('prefs'),
  products: from('products'),
  url: from('url'),
  website: from('website'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/team.ts